"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var i18next_1 = __importDefault(require("i18next"));
var core_1 = require("@material-ui/core");
var home_page_anti_phishing_icon_svg_1 = __importDefault(require("@assets/components/home/feature-list-sliver/home-page-anti-phishing-icon.svg"));
var home_page_customised_icon_svg_1 = __importDefault(require("@assets/components/home/feature-list-sliver/home-page-customised-icon.svg"));
var home_page_analytics_icon_svg_1 = __importDefault(require("@assets/components/home/feature-list-sliver/home-page-analytics-icon.svg"));
var home_page_file_sharing_icon_svg_1 = __importDefault(require("@assets/components/home/feature-list-sliver/home-page-file-sharing-icon.svg"));
var format_1 = require("../../app/util/format");
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a, _b, _c;
    return (0, core_1.createStyles)({
        grid: (_a = {
                marginTop: theme.spacing(2)
            },
            _a[theme.breakpoints.up('lg')] = {
                marginTop: theme.spacing(4),
            },
            _a.maxWidth = '1400px',
            _a.justifyContent = 'space-between',
            _a),
        columnGrid: (_b = {
                maxWidth: 'min(600px, calc(100% + 48px))'
            },
            _b[theme.breakpoints.up('lg')] = {
                maxWidth: '552px',
            },
            _b[theme.breakpoints.up('xl')] = {
                maxWidth: '624px',
            },
            _b),
        card: {
            display: 'flex',
            boxShadow: 'none',
            height: '100%',
            backgroundColor: 'transparent',
            alignItems: 'flex-start',
            flexDirection: 'row',
        },
        cardVectorIcon: (_c = {
                minWidth: '50px',
                marginRight: theme.spacing(2)
            },
            _c[theme.breakpoints.up('lg')] = {
                minWidth: 'auto',
                minHeight: '60px',
                marginRight: theme.spacing(4),
            },
            _c),
        cardContent: {
            paddingTop: theme.spacing(1),
            paddingLeft: theme.spacing(0),
            paddingRight: theme.spacing(0),
            '&:last-child': {
                paddingBottom: 0,
            },
        },
    });
});
var FeatureListSliver = function () {
    var classes = useStyles();
    var theme = (0, core_1.useTheme)();
    var isDesktopWidth = (0, core_1.useMediaQuery)(theme.breakpoints.up('lg'));
    var columns = [
        {
            id: 1,
            data: [
                {
                    icon: home_page_anti_phishing_icon_svg_1.default,
                    title: 'Anti-phishing',
                    description: i18next_1.default.t('homePage.features.antiPhishing.description'),
                },
                {
                    icon: home_page_file_sharing_icon_svg_1.default,
                    title: 'File sharing',
                    description: i18next_1.default.t('homePage.features.fileSharing.description'),
                },
            ],
        },
        {
            id: 2,
            data: [
                {
                    icon: home_page_customised_icon_svg_1.default,
                    title: 'Customised',
                    description: i18next_1.default.t('homePage.features.customised.description'),
                },
                {
                    icon: home_page_analytics_icon_svg_1.default,
                    title: 'Analytics',
                    description: i18next_1.default.t('homePage.features.analytics.description'),
                },
            ],
        },
    ];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Typography, { variant: "h3", color: "textPrimary", display: "inline", gutterBottom: true },
            "Created for ",
            i18next_1.default.t('general.officerType'),
            ' '),
        react_1.default.createElement(core_1.Hidden, { smUp: true },
            react_1.default.createElement("br", null)),
        react_1.default.createElement(core_1.Typography, { variant: "body1", color: "textPrimary", display: "inline", gutterBottom: true, dangerouslySetInnerHTML: {
                __html: (0, format_1.htmlSanitizer)(i18next_1.default.t('homePage.targetUsersPhrase')),
            } }),
        react_1.default.createElement(core_1.Grid, { container: true, className: classes.grid, spacing: 6, direction: !isDesktopWidth ? 'column' : 'row' }, columns.map(function (column) { return (react_1.default.createElement(core_1.Grid, { key: column.id, item: true, container: true, spacing: 6, direction: "column", className: classes.columnGrid }, column.data.map(function (card) { return (react_1.default.createElement(core_1.Grid, { item: true, key: card.title },
            react_1.default.createElement(core_1.Card, { className: classes.card },
                react_1.default.createElement("img", { className: classes.cardVectorIcon, src: card.icon, alt: card.title }),
                react_1.default.createElement(core_1.CardContent, { className: classes.cardContent },
                    react_1.default.createElement(core_1.Typography, { color: "primary", variant: "h4", gutterBottom: true },
                        react_1.default.createElement("strong", null, card.title)),
                    react_1.default.createElement(core_1.Typography, { color: "textPrimary" }, card.description))))); }))); }))));
};
exports.default = FeatureListSliver;
